import { render } from "./Ma_RtxReserveInfo_detail.vue?vue&type=template&id=a2f38cf2&scoped=true"
import script from "./Ma_RtxReserveInfo_detail.vue?vue&type=script&lang=js"
export * from "./Ma_RtxReserveInfo_detail.vue?vue&type=script&lang=js"

import "./Ma_RtxReserveInfo_detail.vue?vue&type=style&index=0&id=a2f38cf2&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2f38cf2"]])

export default __exports__